import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { useHistory, Link } from 'react-router-dom'

import { IconArrowUp, IconRightArrowTable } from '../../../assets/images/icons'
import { useGlobalStore } from '../../../store'
import ImageIcon from '../imageIcon'

import {
  ROLES_MM_PRIMARY,
  ROLES_CLIENT_PRIMARY,
  ROLES_MEMBER,
  ROLES_CLIENT,
} from '../../../constants'

import Slider from 'react-slick'

import {
  CollapseContent,
  TableChipInProgress,
  TableChipAdminReview,
  TableChipCompleted,
  InnerWrapper,
  PhaseWrapper,
  ChipsWrapper,
  ArrowWrapper,
  RhsOuterWrapper,
  RhsWrapper,
  TopSection,
  TopSectionHeading1,
  TopSectionHeading2,
  ImageIconWrapper,
} from './style'
import IconArrowBottom from '../../../assets/images/icons/icon-arrow-bottom'

const defaultCarouselSettings = {
  dots: false,
  infinite: false,
  slidesToShow: 0,
  slidesToScroll: 1,
  vertical: true,
  verticalSwiping: false,
  swipeToSlide: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  beforeChange: function (currentSlide, nextSlide) {
    // console.log("before change", currentSlide, nextSlide);
  },
  afterChange: function (currentSlide) {
    // console.log("after change", currentSlide);
  },
}

const RowDetails = ({ row }) => {
  const [showSlider, setShowSlider] = useState(null)
  const [settings, setSettings] = useState(defaultCarouselSettings)
  const history = useHistory()
  const sliderRef = useRef(null);
  
  useEffect(() => {
    // Only bind when slider is shown and has slides
    if (!showSlider || settings.slidesToShow <= 1) return;

    const sliderInstance = sliderRef.current;
    const sliderEl = sliderInstance?.innerSlider?.list;

    if (!sliderEl) return;

    let throttleTimeout = null;

    const handleWheel = (e) => {
      e.preventDefault();

      if (throttleTimeout) return;

      throttleTimeout = setTimeout(() => {
        throttleTimeout = null;
      }, 200);

      if (e.deltaY < 0) {
        sliderInstance.slickPrev();
      } else {
        sliderInstance.slickNext();
      }
    };

    sliderEl.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      sliderEl.removeEventListener('wheel', handleWheel);
    };
  }, [showSlider, settings.slidesToShow]);

  // if(row?.details?.length === 1 && row.details[0].StudyStatus === 'Completed'){
  //   // history.push(row.details[0].href)
  //   document.getElementById('projectsPageRows').querySelector('a.row').click()
  // }

  const showRhsCarouselFunc = async () => {
    if (row === null) return false
    const rowHeight = row.details.length * 38
    const pageHeaderHeight = window.innerHeight - (80 + 56 + 47)
    if (rowHeight > pageHeaderHeight) {
      const diff = Math.ceil((rowHeight - pageHeaderHeight) / 38)
      const showItemsPerSlide = row.details.length - 3 - diff
      const tempSettings = defaultCarouselSettings
      tempSettings.slidesToShow = showItemsPerSlide
      tempSettings.slidesToScroll = Math.round(showItemsPerSlide / 2)
      setSettings(tempSettings)
    }
    setShowSlider(rowHeight > pageHeaderHeight)
  }

  const sortByCreatedDateFunc = (data) => {
    return data
      .map((d) => ({ ...d, CreatedDateTP: new Date(d.CreatedDate).valueOf() }))
      .sort((a, b) => b.CreatedDateTP - a.CreatedDateTP)
  }

  useEffect(() => {
    showRhsCarouselFunc()
    if (
      row?.details?.length === 1 &&
      document.getElementById('projectsPageRows')?.querySelector('a.row')
    ) {
      // history.push(row.details[0].href)
      document.getElementById('projectsPageRows').querySelector('a.row').click()
    }
  }, [row])

  return (
      <RhsOuterWrapper className='studyTimeLineList' id='projectsPageRows'>
      <TopSection>
        <ImageIcon className='imageIcon' row={row} size='large' />
        <TopSectionHeading1>{row?.BrandName || ''}</TopSectionHeading1>
        <TopSectionHeading2>
          {row?.ProjectType || ''}
          {row?.MarketName ? ', ' : ''} {row?.MarketName || ''}
        </TopSectionHeading2>
      </TopSection>
      {row?.isVisible && row?.details?.length > 0 ? (
        <RhsWrapper>
          <CollapseContent>
            {showSlider && settings?.slidesToShow > 1 ? (
              <Slider ref={sliderRef} {...settings}>
                {sortByCreatedDateFunc(row.details).map((d, i) => (
                  <SliderData key={i} d={d} i={i} />
                ))}
              </Slider>
            ) : (
              <>
                {sortByCreatedDateFunc(row.details).map((d, i) => (
                  <SliderData key={i} d={d} i={i} />
                ))}
              </>
            )}
          </CollapseContent>
        </RhsWrapper>
      ) : (
        <RhsWrapper>
          <CollapseContent>
            <InnerWrapper style={{ height: '50px' }}></InnerWrapper>
          </CollapseContent>
        </RhsWrapper>
      )}
    </RhsOuterWrapper>
  )
}

RowDetails.propTypes = {
  row: PropTypes.object,
  loadingDetails: PropTypes.bool,
}

const SliderData = ({ d }) => {
  const { user } = useGlobalStore()
  return (
    <InnerWrapper type={d.StudyStatus} className={d.StudyStatus}>
      {d.StudyStatus === 'InProgress' && ROLES_MM_PRIMARY.includes(user.UserType) && (
        <Link className='row' to={d.href}>
          <PhaseWrapper>{d.Period}</PhaseWrapper>
          <ChipsWrapper>
            <TableChipInProgress type={d.StudyStatus}> In Progress</TableChipInProgress>
            <IconRightArrowTable />
          </ChipsWrapper>
        </Link>
      )}
      {d.StudyStatus === 'InProgress' && ROLES_CLIENT.includes(user.UserType) && (
        <div className='row'>
          <PhaseWrapper>{d.Period}</PhaseWrapper>
          <ChipsWrapper>
            <TableChipInProgress style={{ cursor: 'default' }} type={d.StudyStatus}>
              {' '}
              In Progress
            </TableChipInProgress>
            <IconRightArrowTable />
          </ChipsWrapper>
        </div>
      )}
      {d.StudyStatus === 'AdminReview' && ROLES_CLIENT_PRIMARY.includes(user.UserType) && (
        <Link className='row' to={d.href}>
          <PhaseWrapper>{d.Period}</PhaseWrapper>
          <ChipsWrapper>
            <TableChipAdminReview type={d.StudyStatus}> Admin Review</TableChipAdminReview>
            <IconRightArrowTable />
          </ChipsWrapper>
        </Link>
      )}
      {d.StudyStatus === 'AdminReview' && [ROLES_MEMBER].includes(user.UserType) && (
        <div className='row'>
          <PhaseWrapper>{d.Period}</PhaseWrapper>
          <ChipsWrapper>
            <TableChipAdminReview style={{ cursor: 'default' }} type={d.StudyStatus}>
              {' '}
              Admin Review
            </TableChipAdminReview>
            <IconRightArrowTable />
          </ChipsWrapper>
        </div>
      )}
      {d.StudyStatus === 'Completed' && (
        <Link className='row' to={d.href}>
          <PhaseWrapper>{d.Period}</PhaseWrapper>
          <ChipsWrapper>
            <TableChipCompleted type={d.StudyStatus}> Completed</TableChipCompleted>
            <IconRightArrowTable />
          </ChipsWrapper>
        </Link>
      )}
    </InnerWrapper>
  )
}

function PrevArrow(props) {
  const { className, onClick, style } = props
  return (
    <div className={className} onClick={onClick} style={style ? { ...style } : undefined}>
      <IconArrowUp />
    </div>
  )
}

function NextArrow(props) {
  const { className, onClick, style } = props
  return (
    <div className={className} onClick={onClick} style={style ? { ...style } : undefined}>
      <IconArrowBottom />
    </div>
  )
}

export default RowDetails
